import React from 'react';
import { css } from '@compiled/react';

import Image from '@atlaskit/image';

const modalImage = css({
	position: 'absolute',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
	height: '100% !important',
	objectFit: 'cover',
	objectPosition: 'center',
});

type ModalImageProps = {
	src: string;
	srcDark: string;
	alt?: string;
};

export function ModalImage({ src, srcDark, alt }: ModalImageProps) {
	return <Image src={src} srcDark={srcDark} css={modalImage} alt={alt} />;
}
